import React from "react";
import { Routes, Route } from "react-router-dom";

import Integration from "./integration";
import NewIntegration from "./integration/newIntegration";
import IntegrationsList from "/app/src/components/generic/components/integration/integrationsView";
import Controls from "/app/src/components/generic/components/integration/_controls";
import { useToggle } from "/app/src/hooks";
import { App } from "/app/src/models";

export default function DataPush({ app }: { app: App }) {
  const [toggled, setToggled] = useToggle();

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Controls
            app={app}
            name="data_push_app"
            toggled={toggled}
            setToggled={setToggled}
          >
            <NewIntegration app={app} setToggled={setToggled} />
          </Controls>
        }
      >
        <Route
          path="integrations/:integrationId/*"
          element={<Integration app={app} />}
        />
        <Route
          path="/"
          element={<IntegrationsList app={app} includeStatus />}
        />
      </Route>
    </Routes>
  );
}
